<template>
  <button
    :class="{ active }"
    @click="attrs.value === '' ? reset() : setItem(attrs.value)"
  >
    <slot />
  </button>
</template>

<script>
import { inject, computed } from '@vue/composition-api'

export default {
  inheritAttrs: false,
  setup(_, { attrs }) {
    const { setItem, item, init, ...rest } = inject(Symbol.for('filter'))
    const active = computed(
      () => (!init.value && attrs.value === '') || item.value === attrs.value
    )
    return {
      attrs,
      setItem,
      active,
      ...rest,
    }
  },
}
</script>
